@if (textArea()) {
  <mdb-form-control>
    <textarea mdbInput
              class="form-control"
              readonly="true"
              [class.bg-white]="white()"
              [class.no-disabled-style]="!disabledStyle() && !white()"
              [value]="value()"
              rows="4"></textarea>
    <label mdbLabel
           class="form-label">{{ label() | translate }}</label>
    <ng-content></ng-content>
  </mdb-form-control>
} @else {
  <mdb-form-control>
    <input mdbInput
           type="text"
           class="form-control"
           readonly="true"
           [class.bg-white]="white()"
           [class.no-disabled-style]="!disabledStyle() && !white()"
           [value]="value()"/>
    <label mdbLabel
           class="form-label">{{ label() | translate }}</label>
    <ng-content></ng-content>
  </mdb-form-control>
}
